// extracted by mini-css-extract-plugin
export default {"contact-form__cols":"contact-form__cols_C0ZA"};